import { StoreData } from "./store.data";
import { TransactionDirection } from "../enum/transactionDirection";
import { GlossDateAsObjectType, GlossQuantityAsObjectType } from "./types/store.types";
import { Origin, TransactionStatusType } from "@bitwarden/web-vault/app/models/types/general-types";
import {
  TransactionOrigin,
  TransactionStatus,
} from "@bitwarden/web-vault/app/models/types/transaction.types";
import { AllocationAsObjectType } from "@bitwarden/web-vault/app/models/store/allocations/allocation.type";

export type TransactionModelVersion = 9;

export interface TransactionStoreModel extends StoreData {
  /**  **Version Number** **/
  v: TransactionModelVersion;

  /** accountId property on transaction type **/
  acId: string;

  /** transaction origin: manual? basiq? plaid? **/
  ori: TransactionOrigin;

  /** bankImportedBalance property on transaction type **/
  bIB: number;

  /** bankImportedBalanceOrigin property on transaction type **/
  bIBO: Origin;

  alc: AllocationAsObjectType[];

  /** definition property on transaction type **/
  dfn: TransactionStatusType;

  /** status property on transaction type **/
  sts: TransactionStatus;

  /** direction property on transaction type **/
  dir: TransactionDirection;

  /** description property on transaction type **/
  dsc: string;

  /** kind property on transaction type **/
  knd: string;

  /** linkedToId property on transaction type **/
  lTid: string[];

  /** excludedLinkIds property on transaction type: ids the user has explicitly
      unlinked so auto-detection must never re-link them **/
  xLid: string[];

  /** quantity property on transaction type **/
  qty: GlossQuantityAsObjectType;

  /** sourceId property on transaction type **/
  srId: string;

  /** transactionDate property on transaction type: when transation is processed by the bank **/
  tDt: GlossDateAsObjectType;

  /** eventDate property on transaction type : when transaction actually happened  **/
  pDt: GlossDateAsObjectType;

  /** valuationPrice property on transaction type **/
  vlPc: number;
}

export const DefaultTransactionStoreModel: TransactionStoreModel = {
  acId: "",
  ori: null,
  bIB: 0,
  bIBO: null,
  alc: [],
  dc: "",
  dfn: undefined,
  dir: undefined,
  dm: "",
  dsc: "",
  id: "",
  knd: "",
  sts: "posted",
  lTid: [],
  xLid: [],
  qty: {
    cvrt: 0,
    cvsym: "",
    ccy: "",
    qty: {
      amt: 0,
      prcs: 0,
      sym: "",
    },
  },
  srId: "",
  tDt: undefined,
  pDt: undefined,
  v: 9,
  vid: "",
  vlPc: null,
};
